import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { split } from 'lodash/fp';
import { ServiceOrderNote } from '@mews-commander/types';
import { UnicodeEntity } from '@mews/enums';

const leadingSpacesRegex = /^([ \t]*)/;
const formatLine = (line: string) => {
    const match = leadingSpacesRegex.exec(line);

    const length = match ? match[1].length : 0;
    const spaces = new Array(length + 1).join(UnicodeEntity.NoBreakSpace);
    return spaces + line.substr(length).replace('\t', `${UnicodeEntity.NoBreakSpace}${UnicodeEntity.NoBreakSpace}`);
};

const formatLineIntoElement = (originalLine: string, noteId: string, index: number) =>
    pipe(originalLine, formatLine, (line) => (
        <div key={`${noteId}-${line}-${index}`}>{line || UnicodeEntity.NoBreakSpace}</div>
    ));

export const getNoteLinesFormatted = ({ id, text }: ServiceOrderNote) =>
    pipe(
        text,
        split(UnicodeEntity.NewLine),
        array.mapWithIndex((index, line) => formatLineIntoElement(line, id, index))
    );
